import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getBrands as fetchAllBrands } from '@store/design/action';

import { blockInfoAddUpdate } from '@services/measurementService';

const BlockDescriptionForm = ({ id, blockResponse = null, onAddSucess }) => {
	const [selectedBlockResponse, setSelectedBlockResponse] = useState(blockResponse);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		setSelectedBlockResponse(blockResponse);
	}, [blockResponse]);

	useEffect(() => {
		dispatch(fetchAllBrands());
	}, []);

	const onSubmitSize = async () => {
		try {
			setIsSubmitting(true);
			let body = {
				blockTitle: selectedBlockResponse?.blockTitle,
				productId: id,
				measurementType: 'NITEX_DEVELOPMENT',
				isBlock: true
			};
			await blockInfoAddUpdate(body);
			onAddSucess();
			setIsSubmitting(false);
		} catch {
			setIsSubmitting(false);
		}
	};

	return (
		<div>
			{' '}
			<div className="form-group mb-2">
				<label htmlFor="block-title">Block title</label>
				<input
					type="text"
					autoComplete="off"
					name="blockTitle"
					value={selectedBlockResponse?.blockTitle}
					onChange={(e) =>
						setSelectedBlockResponse({
							...selectedBlockResponse,
							blockTitle: e.target.value
						})
					}
				/>
			</div>
			<div className="d-flex justify-content-end">
				<button className="button size32 mt-2" onClick={onSubmitSize} disabled={isSubmitting}>
					{selectedBlockResponse?.isBlock ? 'Update' : 'Confirm as Block'}
				</button>
			</div>
		</div>
	);
};

export default BlockDescriptionForm;
